import helper from '@/libs/forms';


export default {
  schema: {
    fields: [
      helper.currency('Net Worth', 'net_worth', true),
      helper.date('Document Date', null, 'date', true, null, '', false, true),
    ],
  },
  options: helper.options('financial-statement-', false),
};



// WEBPACK FOOTER //
// ./src/components/documents/resources/schema.js